<template>
  <Layout>
    <template #header>
      <Heading>{{ $t('ppm_modal__vc_success_heading') }}</Heading>
      <CloseButton @click="$emit('close')" />
    </template>

    <template #default>
      <div class="vcs-main">
        <VirtualECard v-bind="getCardProps(paymentAccount)" />
        <Paragraph>
          {{ $t('ppm_modal__vc_success_text_p1') }}
        </Paragraph>
      </div>
    </template>

    <template #footer>
      <HotPinkButton @click="$emit('confirm')">
        {{ confirmText }}
      </HotPinkButton>
    </template>
  </Layout>
</template>

<script>
import Layout from '../../layouts/Layout.vue'
import Heading from '../../typography/Heading.vue'
import Paragraph from '../../typography/Paragraph.vue'
import VirtualECard from '../../cards/VirtualECard.vue'
import HotPinkButton from '../../buttons/HotPinkButton.vue'
import CardMixin from '../../mixins/CardMixin'
import CloseButton from '@/components/shared/Dialogs/CloseButton.vue'

export default {
  components: {
    Layout,
    Heading,
    Paragraph,
    VirtualECard,
    HotPinkButton,
    CloseButton,
  },
  mixins: [CardMixin],
  props: {
    paymentAccount: {
      type: Object,
      required: true,
    },
    confirmText: {
      type: String,
      default: 'Continue',
    },
  },
}
</script>

<style lang="postcss" scoped>
.vcs-main {
  /* Base */
  @apply tw-flex tw-flex-col tw-items-center tw-gap-6 tw-mt-14;

  /* Desktop  */
  @apply lg:tw-mt-11 lg:tw-mb-7;
}
</style>
